// src/components/store/HeroSlider.tsx
"use client";

import { HERO_BANNER_VARIANTS } from "./sections/hero-banner";

interface HeroSliderProps {
  banners: any[];
  categories?: any[];
  variant?: string;
  primaryColor?: string;
  subdomain?: string;
}

export default function HeroSlider({
  banners,
  categories = [],
  variant = "category_sidebar",
  primaryColor = "#ff5722",
  subdomain = "nextlook",
}: HeroSliderProps) {
  const Component = HERO_BANNER_VARIANTS[variant] || HERO_BANNER_VARIANTS["category_sidebar"] || HERO_BANNER_VARIANTS["slider_classic"];

  return (
    <Component
      banners={banners}
      categories={categories}
      primaryColor={primaryColor}
      subdomain={subdomain}
    />
  );
}